"use client";

import { forwardRef } from "react";
import { Link as IntlLink } from "@/i18n/navigation";

import type { ComponentPropsWithoutRef, ForwardedRef } from "react";

// * Обёртка вокруг IntlLink для Chakra UI `as`
export const I18nLink = forwardRef<HTMLAnchorElement, ComponentPropsWithoutRef<typeof IntlLink>>(function I18nLink(
  { prefetch = false, ...props },
  ref: ForwardedRef<HTMLAnchorElement>
) {
  return <IntlLink {...props} ref={ref} prefetch={prefetch} />;
});
